import React, { Component } from "react";
import { connect } from "react-redux";
import MenuIcon from "@material-ui/icons/Menu";
import history from "../Utils/History";
import PlanCard from "./PlanCard";
import Snackbar from "@material-ui/core/Snackbar";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import SimpleReactValidator from "simple-react-validator";
import { Text } from "react-internationalization";
import {
  getAgentIDListInPreEnrollForm,
  setFormData,
  getPlanDetails,
  planSelectionContinue,
  yearSelection,
  setStateParams,
  setEnrollRedirect,
  getPlans,
  sendEmail,
  getZipCodes,
} from "../Redux/Actions/webAppActions";
import Modal from "../Utils/GenericUI/Modal/Modal";
import Footer from "../Themes/Footer";
import { VERDA_CONSTS } from "../Utils/StaticData/Constant";
import { lang } from "moment/moment";
class PlansList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comparePlans: this.props.compareList,
      cardData: this.props.cardDetails,
      filtredCardData: [],
      matchFound: true,
      initialRender: true,
      disablePlan: false,
      clicked: false,
      value:
        this.props.deeplink === true
          ? this.props.dpzipCode
          : this.props.zipCode,
      planNotAvailable: false,
      countySelect: this.props.countyName,
      errorMsg: "",
      popUp: false,
      emailPlanId: "",
      snackBarOpen: false,
      snackBarMsg: "",
      vertical: "center",
      horizontal: "center",
      snackBarSeverty: "",
      zipCode: this.props.zipCode,
      displayZipCode: false,
      teleScript: true,
    };
    this.validator = new SimpleReactValidator();
  }

  redirect = (event) => {
    event.preventDefault();
    this.setState({
      clicked: true,
      openModal: false,
      popUp: false,
      displayZipCode: this.props.zipCode !== "" ? true : false,
    });
    this.props.handleHeaderWidth();
  };

  componentDidMount() {
    this.setState({
      clicked: false,
    });
  }
  handleSelect = async (
    event,
    planId,
    planName,
    productName,
    productId,
    premiumAmount,
    productCategory,
    pbpId
  ) => {
    event.preventDefault();
    if (
      (this.props?.prospectEnroll === true ||
        this?.props?.previewToSelectplan === true) &&
      this?.props?.appNum
    ) {
      await this.props.setEnrollRedirect(
        this?.props?.appNum,
        this.props.agentEmailId,
        this.props?.customerId
      );
      this.props.setStateParams("loadApi", true);
      this.props.setStateParams("pendingApplFlag", true);
    }
    this.props.setStateParams("productCategory", productCategory.trim());
    this.props.setStateParams("product", productName.trim());
    let planSelected = {
      planId: planId,
      pbpId: pbpId,
    };
    this.props.setStateParams("planSelected", planSelected);
    let formPayload = {
      planId: planId,
      planName: planName,
      plan: planId,
      productId: productId,
      productCategory: productCategory ? productCategory : "",
    };
    this.props.setFormData({
      ...formPayload,
      productName: productName,
      productId: productId,
      premiumAmount: premiumAmount,
    });
    let payload = {
      planId: planId,
      customerId: this.props?.customerId,
      productId: productId,
      premiumAmount: premiumAmount,
    };
    let plnType = this.props.cardDetails.filter(
      (x) => x.productId === productId
    )[0].planType;
    let response = await this.props.planSelectionContinue(
      payload,
      this.props?.customerId
    );
    if (response.status === "OK") {
      {
        this.props?.agentLogin === true &&
          this.props?.customerId !== VERDA_CONSTS.ID &&
          (await this.props.getAgentIDListInPreEnrollForm(
            this.props?.customerId
          ));
      }
      //this.props.setStateParams("selectedPlanDetails", payload);
      window.sessionStorage.setItem("planName", this.props.selectedPlanName);

      window.sessionStorage.setItem(
        "selectedPlanDetails",
        JSON.stringify(payload)
      );
      if (
        this.props?.prospectEnroll !== true &&
        this?.props?.previewToSelectplan !== true
      ) {
        this.props.setStateParams("isUpdated", false);
        await this.props.setStateParams("appNum", null);
        await this.props.setStateParams("guestbeneagentAppNum", null);
        await this.props.setStateParams("pendingApplFlag", false);
      }
      // if(this.props?.prospectEnroll===true && this.props?.appNum){

      // }
      await this.props.setStateParams("planType", plnType);
      await this.props.setStateParams("selectedVo", []);
      this.props.setStateParams("selectedIndex", null);
      history.push("/e-Enroll/enrollOnline");
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor, inténtalo después de un tiempo"
            : "Please Try after some time",
        snackBarSeverty: "error",
      });
    }
  };
  static getDerivedStateFromProps(nextProps, state) {
    let compareLists = state.comparePlans;
    let disablePlans = state.disablePlan;
    if (state.comparePlans != nextProps.compareList) {
      compareLists = nextProps.compareList;
      disablePlans = false;
    }
    if (
      nextProps.planTypeFilter !== "" ||
      nextProps.productFilter !== "" ||
      nextProps.premiumFilter !== ""
    ) {
      let temp = nextProps.cardDetails;
      let newCardData = [];
      const planType = nextProps.planTypeFilter;
      const productType = nextProps.productFilter;
      const premiumType =
        nextProps.premiumFilter !== "" ? parseInt(nextProps.premiumFilter) : "";
      if (
        nextProps.planTypeFilter !== "" &&
        nextProps.productFilter !== "" &&
        nextProps.premiumFilter
      ) {
        newCardData = temp.filter(
          (current, i) =>
            temp[i].type.includes(planType) &&
            productType === temp[i].productName.trim() &&
            parseInt(temp[i].monthlyPremium) <= premiumType
        );

        return {
          cardData: newCardData,
          matchFound: newCardData.length > 0 ? true : false,
          comparePlans: compareLists,
          disablePlan: disablePlans,
          // comparePlans: [],
        };
      } else if (
        (nextProps.planTypeFilter !== "" &&
          nextProps.premiumFilter !== "" &&
          nextProps.productFilter === "") ||
        (nextProps.premiumFilter !== "" &&
          nextProps.productFilter !== "" &&
          nextProps.planTypeFilter === "") ||
        (nextProps.planTypeFilter !== "" &&
          nextProps.productFilter !== "" &&
          nextProps.premiumFilter === "")
      ) {
        newCardData = temp.filter(
          (current, i) =>
            (planType !== "" &&
              premiumType !== "" &&
              productType === "" &&
              temp[i].type.includes(planType) &&
              parseInt(temp[i].monthlyPremium) <= parseInt(premiumType)) ||
            (premiumType !== "" &&
              productType !== "" &&
              planType === "" &&
              (productType === temp[i].productName.trim() ||
                productType === temp[i]?.productCategory?.trim()) &&
              parseInt(temp[i].monthlyPremium) <= parseInt(premiumType)) ||
            (planType !== "" &&
              temp[i] &&
              temp[i].planType &&
              productType !== "" &&
              premiumType === "" &&
              temp[i].planType.trim() === planType &&
              (productType === temp[i].productName.trim() ||
                productType === temp[i]?.productCategory?.trim()))
        );
        // console.log("clsnewcarddatasub",newCardData)

        return {
          cardData: newCardData,
          matchFound: newCardData.length > 0 ? true : false,
          comparePlans: compareLists,
          disablePlan: disablePlans,
          // comparePlans: [],
        };
      } else {
        //Filter product by product category only for sharp..
        if (nextProps?.customerId === "HCF0331") {
          newCardData = temp.filter(
            (current, i) =>
              current.productCategory === nextProps.productFilter ||
              (planType !== "" &&
                temp[i].type &&
                temp[i].type?.includes(planType)) ||
              (productType !== "" &&
                productType === temp[i].productCategory.trim()) ||
              (premiumType !== "" &&
                parseInt(temp[i].monthlyPremium) <= parseInt(premiumType))
          );
        } else {
          newCardData = temp.filter(
            (current, i) =>
              (planType !== "" &&
                temp[i].type &&
                temp[i].type.includes(planType)) ||
              (productType !== "" &&
                productType === temp[i].productName.trim()) ||
              (premiumType !== "" &&
                parseInt(temp[i].monthlyPremium) <= parseInt(premiumType))
          );
        }
        // console.log("3","temp",temp,"planType",planType,"productType",productType,"premiumType",premiumType)
        // console.log("clsnewcarddatamain",newCardData)
        return {
          cardData: newCardData,
          matchFound: newCardData.length > 0 ? true : false,
          comparePlans: compareLists,
          disablePlan: disablePlans,
          // comparePlans: [],
        };
      }
    } else {
      return {
        cardData: nextProps.cardDetails,
        matchFound: true,
        comparePlans: compareLists,
        disablePlan: disablePlans,
      };
    }
  }

  handleCheckedPlan = async (event) => {
    let checkedPlans = this.state.comparePlans;

    let index = checkedPlans.indexOf(event.target.value);
    if (index !== -1) {
      checkedPlans.splice(index, 1);
    } else {
      if (this.state.comparePlans.length < 3) {
        checkedPlans.push(event.target.value);
      }
    }
    await this.setState({
      comparePlans: checkedPlans,
    });
    if (this.state.comparePlans.length > 2) {
      this.setState({
        disablePlan: true,
      });
    } else if (this.state.comparePlans.length < 3) {
      this.setState({
        disablePlan: false,
      });
    }
    this.props.setStateParams(
      "selectedPlansForCompare",
      this.state.comparePlans
    );
    this.props.handleCompareList(this.state.comparePlans);
  };
  handleChange1 = (event) => {
    let value = event.target ? event.target.value : event.value;
    let name = event.target ? event.target.name : event.name;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    let stateId = this.props.ZipCodes.filter((f) => f.countyName === value)[0]
      ?.stateCd;
    this.props.setStateParams("stateId", stateId);
  };

  handleChange = async (event) => {
    // const name = event.target.name;
    let valueinput = event.target.value;
    valueinput = valueinput.replace(/[^0-9]+/g, "");
    await this.setState({
      value: valueinput,
      zipCode: valueinput,
    });

    if (valueinput.length === 5) {
      // if (valueinput !== this.props.zipCode) {
      this.setState({ teleScript: false });
      const zipresponse = await this.props.getZipCodes(valueinput);
      this.props.setStateParams("zip", valueinput);
      // }
      if (zipresponse.status === "OK") {
        if (this.props.ZipCodes && this.props.ZipCodes.length > 0) {
          this.setState({
            // planNotAvailable: true,
            displayZipCode: true,
            errorMsg: "",
          });
        } else {
          this.setState({
            // planNotAvailable: false,
            displayZipCode: true,
          });
        }
      } else {
        this.props.setStateParams("zipCodes", {});
        this.setState({
          // planNotAvailable: true,
          errorMsg:
            this.props.lang === "es"
              ? "Ingrese el código postal adecuado."
              : "Please enter proper zip code.",
          displayZipCode: false,
        });
      }
    } else {
      this.setState({
        // planNotAvailable: true,
        errorMsg:
          this.props.lang === "es"
            ? "Ingrese el código postal adecuado."
            : "Please enter proper zip code.",
        displayZipCode: false,
      });
    }
  };

  continue = async (event) => {
    let zipcode = this.state.value;
    event.preventDefault();
    let response = [];
    if (zipcode.length === 5) {
      let call = true;
      if (this.props.ZipCodes && this.props.ZipCodes.length === 1) {
        await this.props.setStateParams("county", this.props.ZipCodes[0]);
        await this.props.setStateParams("state", this.props.ZipCodes.state);
      } else if (
        this.props.ZipCodes &&
        this.props.ZipCodes.length > 1 &&
        this.state.countySelect !== ""
      ) {
        await this.props.setStateParams("county", this.state.countySelect);

        // const params =
        this.props.ZipCodes.filter(
          (zipcode1) => zipcode1.countyName === this.props.county
        );

        await this.props.setStateParams("state", this.props.ZipCodes.state);
      } else if (this.props?.ZipCodes?.length === undefined) {
        call = false;
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "No se encontraron planes para este código postal"
              : "No plans found for this Zip code",
          snackBarSeverty: "error",
          planNotAvailable: true,
        });
      } else {
        call = false;
        this.setState({
          planNotAvailable: true,
          errorMsg:
            this.props.lang === "es"
              ? "Seleccione un condado"
              : "Please Select a County",
        });
      }

      if (call === true) {
        let body = { customerId: this.props?.customerId };
        let params = "";
        if (this.props.ZipCodes.length > 1) {
          params = this.props.ZipCodes.filter(
            (zipcode1) => zipcode1.countyName === this.props.county
          );
        } else {
          params = this.props.ZipCodes;
        }

        response = await this.props.getPlans(
          zipcode,
          //this.props.county.countyCode,
          params[0]?.countyCode,
          body.customerId,
          //this.props.county.stateCode
          this.props.stateCd,
          this?.props?.year
        );
        if (this.props.cardDetails.length > 0) {
          this.setState({
            planNotAvailable: false,
            clicked: false,
            teleScript: true,
          });
          //let payload = { planYear: "2023" };
          //this.props.yearSelection(payload);
          history.push("/e-Enroll/select-plan");
        } else {
          this.setState({
            planNotAvailable: true,
            errorMsg: response.message,
            clicked: false,
            teleScript: false,
          });
        }
      }
    } else {
      this.setState({
        planNotAvailable: true,
        errorMsg:
          this.props.lang === "es"
            ? "¡Seleccione un código postal!"
            : "Please Select a ZipCode!",
      });
    }
    this.props.handleHeaderWidth();
  };

  modalClosed = () => {
    // serviceMsg("");
    this.setState({
      popUp: false,
    });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  openModal = (planId) => async (e) => {
    e.preventDefault();

    this.setState({
      popUp: true,
      emailPlanId: planId,
    });
  };

  sendEmail = async (email) => {
    const { monthlyPremium, planName, productId } = this.props.cardDetails.find(
      (card) => card.productId === this.state.emailPlanId
    );
    if (!this.validator.check(email, "email")) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor introduzca una dirección de correo electrónico válida"
            : "Please enter a valid email",
        snackBarSeverty: "error",
      });
    } else {
      let payload = {
        // planId: this.state.emailPlanId,
        recipient: email,
        // zipCode: this.props.zipCode,
        // state: this.props.stateName,
        // county: this.props.countyName,
        planName,
        monthlyPremium,
        zipCd: this.props.zipCode,
        //countyCd: this.props.county.countyCode,
        countyCd: this.props.ZipCodes[0].countyCode,
        customerId: this.props?.customerId,
        stateCd: this.props.stateCd,
        countyName: this.props.countyName.trim(),
        productId,
        planYear: this?.props?.year,
        userRole: this.props.beneficiaryLogin
          ? "beneficiary"
          : this.props.agentLogin
          ? "agent"
          : "guest",
        lang: this.props.lang,
      };
      let response = await this.props.sendEmail(payload);
      this.setState({
        popUp: false,
      });
      //let response = await this.props.sendEmail(payload);
      if (response.status === "OK") {
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "El correo enviado con éxito"
              : "Mail sent successfully",
          snackBarSeverty: "success",
        });
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg:
            this.props.lang === "es"
              ? "Ocurrió un error al enviar el correo electrónico."
              : "Error occured while sending email.",
          snackBarSeverty: "error",
        });
      }
    }
  };
  // componentDidUpdate(prevState, prevProps) {
  //   if (
  //     prevState.comparePlans != this.props.compareList
  //   ) {
  //     this.setState({
  //       comparePlans:this.props.compareList
  //     });
  //   }
  // }
  render() {
    // console.log("in list",this.props.planTypeFilter,"pro-",this.props.productFilter,this.props.premiumFilter)
    const {
      displayZipCode,
      comparePlans,
      cardData,
      matchFound,
      countySelect,
      value,
      planNotAvailable,
      errorMsg,
      snackBarOpen,
      snackBarMsg,
      vertical,
      horizontal,
      snackBarSeverty,
    } = this.state;

    const { countyName, zipCode, ZipCodes } = this.props;
    const county =
      typeof countyName === "string" || countyName === undefined
        ? countyName
        : countyName.countyName;
    return (
      <div
        class={
          this.props.agentLogin === true
            ? "content position-relative margin-top-agent "
            : "content position-relative margin-top-user"
        }
      >
        <div class="toggle-button-container container-webApp ">
          <div
            class={
              !this.props.sidebarExpanded
                ? "row toggle-bar-container"
                : "row toggle-bar-container mobile-display-none"
            }
          >
            <div class="">
              <Snackbar
                open={snackBarOpen}
                autoHideDuration={6000}
                onClose={this.handleClose}
                anchorOrigin={{ vertical, horizontal }}
                key={vertical + horizontal}
              >
                <Alert onClose={this.handleClose} severity={snackBarSeverty}>
                  {snackBarMsg}
                </Alert>
              </Snackbar>
              <Modal
                idName={"modalWidth"}
                paddingHeading="5px"
                dialogTitle={<Text id="plan.smt" />}
                message={<Text id="plan.peye" />}
                show={this.state.popUp}
                modalClosed={() => {
                  this.modalClosed();
                }}
                sendEmail={this.sendEmail}
                inputField
                sendButton
                cancelButton
                lang={this.props.lang}
              ></Modal>
              {
                // <button
                //   type="button"
                //   id="sidebarCollapse"
                //   class="btn btn-toggle display-flex"
                //   onClick={this.props.toggle}
                // >
                //   <MenuIcon />
                //   {/*<span class=" btn-toggle-text ml-2">Toggle Sidebar</span>*/}
                // </button>
                !this.props.sidebarExpanded ? (
                  <a
                    class="btn btn-sidebaricon-hide1 display-flex btn-toggle justify-content-center"
                    onClick={this.props.toggle}
                  >
                    <MenuIcon />
                  </a>
                ) : null
              }
            </div>
            <div
              class={
                (this.props.sidebarExpanded && this.state.clicked
                  ? "zip-aligner1 "
                  : "zip-aligner ") + (this.state.clicked && "edit-zip")
              }
            >
              {this.state.clicked === false ? (
                this.props.deeplink === true ? (
                  <p class="header-address">
                    {/* state is removed */}
                    <strong>
                      {this.props.dpcountyName && this.props.dpzipCode
                        ? this.props.dpcountyName + " " + this.props.dpzipCode
                        : ""}
                    </strong>{" "}
                    <button
                      class="btn btn-secondary btn-blue ml-2"
                      onClick={this.redirect}
                    >
                      <Text id="app.edit" />
                    </button>
                  </p>
                ) : (
                  <p class="header-address">
                    {/* state is removed */}
                    <strong>
                      {county && zipCode
                        ? county + " " + zipCode
                        : this.props.dpcountyName && this.props.dpzipCode
                        ? this.props.dpcountyName + " " + this.props.dpzipCode
                        : ""}
                    </strong>{" "}
                    <button
                      class="btn btn-secondary btn-blue ml-2"
                      onClick={this.redirect}
                    >
                      <Text id="app.edit" />
                    </button>
                  </p>
                )
              ) : (
                <p
                  className={
                    this.props.sidebarExpanded
                      ? "zipcode-togglebar-header-mobile-aligner1"
                      : "zipcode-togglebar-header-mobile-aligner"
                  }
                >
                  <div
                    class="display-flex"
                    //style={{ float: "right" }}
                  >
                    <label
                      for="permanentZip"
                      class={
                        this.props.sidebarExpanded
                          ? "control-label ext2 zip-mobile-position-handler1"
                          : "control-label ext1 zip-mobile-position-handler"
                      }
                      // style={{ paddingRight: "5.2rem!important" }}
                    >
                      <Text id="zipcode.head" />
                    </label>
                    <div class="zipcode-planslist">
                      <div class="onboarding__input-wrapper">
                        {displayZipCode === false ? (
                          <React.Fragment>
                            <input
                              type="text"
                              name="permanentZip"
                              id="permanentZip"
                              value={value}
                              minlength="5"
                              maxlength="5"
                              required
                              onChange={this.handleChange}
                              placeholder="Enter Zip Code"
                              autofocus="autofocus"
                              autoComplete="off"
                              spellcheck="false"
                              aria-autocomplete="both"
                              aria-haspopup="false"
                            />
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div class="label fill">
                              <span>{value}</span>
                              <i
                                class="fas fa-times-circle remove"
                                onClick={() => {
                                  this.setState({
                                    displayZipCode: false,
                                    countySelect: "",
                                    value: "",
                                  });
                                }}
                              ></i>
                            </div>

                            {ZipCodes.length > 1 ? (
                              <React.Fragment>
                                {countySelect !== "" ? (
                                  <div class="label fill">
                                    <span>{countySelect}</span>
                                    <i
                                      class="fas fa-times-circle remove"
                                      onClick={() => {
                                        this.setState({
                                          countySelect: "",
                                        });
                                      }}
                                    ></i>
                                  </div>
                                ) : (
                                  <div class="onboarding__select-wrapper select-active">
                                    <select
                                      id="countySelect"
                                      name="countySelect"
                                      value={countySelect}
                                      onChange={this.handleChange1}
                                    >
                                      <option value="">Select a County</option>
                                      {ZipCodes.map((county1) => (
                                        <option value={county1.countyName}>
                                          {county1.countyName.trim()}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )}
                              </React.Fragment>
                            ) : (
                              <div class="label fill">
                                {ZipCodes.length !== 0 && (
                                  <span>{ZipCodes[0]?.countyName}</span>
                                )}
                              </div>
                            )}
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                    <div>
                      <button
                        class="btn btn-secondary btn-blue ml-2 padding-btn mb-1-5em"
                        onClick={this.continue}
                      >
                        <Text id="app.ok" />
                      </button>
                    </div>
                  </div>
                </p>
              )}
            </div>
          </div>

          <div class="tab-content-plan">
            <div class="container-webApp tab-pane">
              {planNotAvailable === true ? (
                <div
                //style={{ width: "100%", marginTop: "3rem", textAlign: "end" }}
                >
                  <p class="error-label">{errorMsg}</p>
                </div>
              ) : (
                ""
              )}
              {planNotAvailable === true ? (
                <h3 class="tab-heading mt-5">
                  <Text id="app.ndfVanilla" />
                </h3>
              ) : (
                <>
                  {cardData.length >= 1 && matchFound ? (
                    <h3 class="tab-heading mt-5">
                      <Text id="app.syp" />
                    </h3>
                  ) : (
                    <h3 class="tab-heading mt-5">
                      <Text id="app.ndfVanilla" />
                    </h3>
                  )}
                </>
              )}
              {!planNotAvailable && (
                <Grid
                  container
                  // style={{ marginLeft: "10px" }} // REMOVE FOR MOBILE VERSION-----------
                  justifyContent="left"
                  alignItems="center"
                >
                  {!this.props.deeplink && cardData && matchFound
                    ? cardData.map((cardDetail) => (
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                          {
                            <PlanCard
                              productFilter={this.props.productFilter}
                              teleScript={this.state.teleScript}
                              cardData={cardDetail}
                              openModal={this.openModal}
                              handleCheckedPlan={this.handleCheckedPlan}
                              comparePlans={comparePlans}
                              isSelected={
                                comparePlans.indexOf(cardDetail.productId) !==
                                -1
                              }
                              handleSelect={this.handleSelect}
                              disablePlan={this.state.disablePlan}
                              sidebarexpanded={this.props.sidebarExpanded}
                            />
                          }
                        </Grid>
                      ))
                    : planNotAvailable === true
                    ? ""
                    : null}
                </Grid>
              )}
              {!planNotAvailable && (
                <Grid
                  container
                  // style={{ marginLeft: "10px" }} // REMOVE FOR MOBILE VERSION-----------
                  justifyContent="left"
                  alignItems="center"
                >
                  {this.props.deeplink && cardData && matchFound
                    ? cardData.map(
                        (cardDetail) =>
                          //cardDetail.productId === this.props.dpProductId && (
                          cardDetail.productId.includes(
                            this.props.dpProductId
                          ) && (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                              {
                                <PlanCard
                                  teleScript={this.state.teleScript}
                                  // cardData={cardData.find(ele=>ele.productId===this.props.dpProductId)}
                                  cardData={cardDetail}
                                  openModal={this.openModal}
                                  handleCheckedPlan={this.handleCheckedPlan}
                                  comparePlans={comparePlans}
                                  isSelected={
                                    comparePlans.indexOf(
                                      cardDetail.productId
                                    ) !== -1
                                  }
                                  handleSelect={this.handleSelect}
                                  disablePlan={this.state.disablePlan}
                                />
                              }
                            </Grid>
                          )
                      )
                    : planNotAvailable === true
                    ? ""
                    : null}
                </Grid>
              )}
              {/* </Grid> */}
            </div>
          </div>
        </div>
        <div>
          {/* <Footer1 matchFound={matchFound} /> */}
          {/* <FooterContainer matchFound={matchFound}/> */}
          <Footer
            matchFound={matchFound}
            customerId={this.props.customerId}
            theme={this.props.theme}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { selectedPlanName, stateCd } = state.webApp;
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    cardDetails: state.webApp.planCardData,
    zipCode: state.webApp.zip,
    guestLoggedIn: state.login.guestLogin,
    stateName: state.webApp.state,
    countyName: state.webApp.county?.countyName
      ? state.webApp.county?.countyName
      : state.webApp.county,
    email: state.login.emailAddress,
    customerId: state.login.customerId,
    planId: state.webApp.emailPlanId,
    agentLogin: state.login.agentLoggedIn,
    beneficiaryLogin: state.login.beneficiaryLogin,
    ZipCodes: state.webApp.zipCodes,
    county: state.webApp.county,
    selectedPlanName,
    // county,
    stateCd,
    deeplink: state.login.deeplink,
    dpcountyName: state.login.dpcountyName,
    dpzipCode: state.login.dpzipCode,
    dpProductId: state.login.dpProductId,
    countyCode: state.webApp.countyCode,
    // customerId:state.login.customerId,
    theme: state.login.theme,
    prospectEnroll: state.webApp.prospectEnroll,
    previewToSelectplan: state.webApp.previewToSelectplan,
    appNum: state.webApp.appNum,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    //selectedPlanDetails: state.webApp.selectedPlanDetails,
    lang: state.webApp.language,
    agentEmailId: state.login.agentEmailId,
  };
};
const mapDispatchToProps = {
  getAgentIDListInPreEnrollForm,
  setFormData,
  getPlanDetails,
  planSelectionContinue,
  yearSelection,
  setStateParams,
  setEnrollRedirect,
  getPlans,
  sendEmail,
  getZipCodes,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlansList);
